import { useCallback } from 'react';

import { getInvitees } from '@atlassian/invite-prompt';
import type { Invitees } from '@atlassian/invite-prompt';

import { useSessionData } from '@confluence/session-data';

const PRODUCT = 'jira-software';

export const useGetInviteesFromExus = () => {
	const { cloudId: confluenceCloudId } = useSessionData();
	return useCallback(
		async (spaceKey: string, jiraCloudId: string): Promise<Invitees> => {
			const response = await getInvitees(PRODUCT, jiraCloudId, confluenceCloudId, spaceKey);
			if (response.ineligibilityReason === undefined || response.ineligibilityReason === null) {
				return response.invitees;
			} else {
				return [];
			}
		},
		[confluenceCloudId],
	);
};
